<template>
	<Field class="text-field">
		<template #default="slot">
			<input v-model="model" :type="type" v-bind="slot"/>
		</template>
	</Field>
</template>

<script lang="ts">
import usePropModel from '#/usePropModel'

import { defineComponent, watchEffect } from 'vue'

import Field from './Field.vue'

export default defineComponent({
	name: 'TextArea',

	components: {
		Field
	},

	props: {
		modelValue: { type: [Number, String], default: '' },
		type: { type: String, default: 'text' }
	},

	setup (props, { emit }) {
		const model = usePropModel(props, emit)

		return { model }
	}
})
</script>